module.exports = __webpack_public_path__ + "static/media/bgfinal.3a409182.jpg";